module.exports = __webpack_public_path__ + "static/img/monitor.7eeb6217.svg";